/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import get from 'lodash/get';
import { formMessageConstants } from '../../utils/constants/form-message-constants';
import { formFieldConstants } from '../../utils/constants/form-field-constants';
import { formConstants } from '../../utils/constants/form-constants';
import FormBuilder from '../helpers/form-builder';
import FormMessage from '../../common/utility/FormMessage';
import FormSpinner from '../../common/utility/FormSpinner';
import * as upgradeAccountActions from '../../../store/actions/upgrade-account-actions';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as userAddressActions from '../../../store/actions/user-address-actions';
import * as basketActions from '../../../store/actions/basket-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import * as formScrollHelpers from '../helpers/form-scroll-helper';
import * as formFieldDisplayHelpers from '../helpers/form-helpers/form-field-display-helpers';
import { findOptionInSelectField } from '../helpers/form-helpers/form-field-helpers';
import * as upgradeFormHelper from '../helpers/form-helpers/upgrade-form-helper';
import initialState from '../helpers/form-helpers/initial-state';
import SSOFormHeader from '../../common/utility/SSOFormHeader';
import SSOFormFooter from '../../common/utility/SSOFormFooter';
import { isEmpty, deepCopyObject } from '../../utils/obj-utils';
import { ssoFormTypes } from '../../utils/form-types';
import GTMUserActions from '../../common/utility/GTMUserActions';
import { updateTOCHUserMemberships } from '../../../../../general/js/helpers';
import { updateUserDataCookie } from '../../utils/user-data-cookie/user-data-cookie-helpers';
import { getFormContainerWideLeftClassList, toggleBemClassesForSSOFormModal } from '../helpers/form-helpers/form-modal-helpers';
import { hasValue, isNullOrUndefined, toggleCssClass } from '../../../../../general/js/general-helpers';
import { createDate } from '../../utils/date-utils';
import { MembershipTypes, redirectTo, reloadPage } from '../../../../../general/js/utils';

class UpgradeToOneClubAccountForm extends Component {
    constructor(props) {
        super(props);
        const { formData } = this.props;

        const mainAddress = upgradeFormHelper.getMainAddress(formData.currentUser);
        const formType = get(formData, formConstants.formType, null);
        const birthDate = upgradeFormHelper.getDateOfBirth(formData.currentUser);

        this.state = {
            ...initialState.upgradeAccountFormState,
            [formConstants.title]: upgradeFormHelper.getTitle(formData.currentUser),
            [formConstants.dateOfBirth]: birthDate ? createDate(birthDate.year, birthDate.month, birthDate.day) : null,
            [formConstants.country]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.country),
            [formConstants.county]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.county),
            [formConstants.state]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.state),
            [formConstants.city]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.city),
            [formConstants.addressLine1]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine1),
            [formConstants.addressLine2]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine2),
            [formConstants.addressLine3]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.addressLine3),
            [formConstants.postcode]: upgradeFormHelper.getPropertyFromMainAddress(mainAddress, formConstants.postcode),
            [formConstants.mobilePhone]: upgradeFormHelper.getMobilePhone(formData, formConstants),
            [formConstants.formType]: formType
        };

        this.formMessageRef = React.createRef();
        this.formReference = React.createRef();

        this.displayUpgradeToOneClubAccountForm = this.displayUpgradeToOneClubAccountForm.bind(this);
        this.displayForm = this.displayForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidationResult = this.handleValidationResult.bind(this);
        this.handleAccountUpgradeSuccess = this.handleAccountUpgradeSuccess.bind(this);
        this.submitUserDetailsData = this.submitUserDetailsData.bind(this);

        this.formReferences = formScrollHelpers.getFormReferences(formData);
    }

    componentDidMount() {
        const { onSignIn, formData, ssoFormType } = this.props;

        if (isEmpty(formData)) {
            onSignIn();
        }

        this.hideModalCloseButton();

        if (ssoFormType === ssoFormTypes.UpgradeToOneClubAccountFromDefault) {
            toggleBemClassesForSSOFormModal(this.formReference, this.props, ssoFormType);
        }

        this.updateActiveMemberships();

        this.updateAvailableCounties();

        this.updateAvailableStates();
    }

    async componentWillReceiveProps(nextProps) {
        const {
            formData,
            isUpgradeSuccessful,
            loading,
            retrievedUserAddress,
            isUserAddressRetrieveSuccessful
        } = nextProps;

        const { isSubmitAction } = this.state;

        this.hideModalCloseButton(nextProps);

        if (!loading && (!isSubmitAction && isUserAddressRetrieveSuccessful)) {
            const { county, state } = formData;
            this.setState(formStateHelpers.handleAddressDataChange(retrievedUserAddress, county, state));
        }

        if (!loading &&
            isUpgradeSuccessful) {
            updateTOCHUserMemberships('OneClub');
            await updateUserDataCookie(true, true);
            this.setState(formStateHelpers.updateSavingState(false), this.handleAccountUpgradeSuccess);
            return;
        }

        if (!loading &&
            !isUpgradeSuccessful) {
            this.setState(formStateHelpers.updateSavingState(false),
                () => {
                    formScrollHelpers.scrollToField(this.formMessageRef);
                    this.setState(formStateHelpers.handleSubmit(false));
                });
        }
    }

    componentWillUnmount() {
        const { actions } = this.props;
        this.setState(initialState.upgradeAccountFormState);
        actions.resetUpgradeAccountFormState();
    }


    hideModalCloseButton(nextProps = {}) {
        const { formData } = hasValue(nextProps) ? nextProps : this.props;
        const { hideCloseButton } = hasValue(formData) ? formData : { hideCloseButton: false };

        if (hideCloseButton) {
            const closeButton = document.querySelector('.modal__close');

            if (!isNullOrUndefined(closeButton)) {
                toggleCssClass(closeButton, 'is-hidden', hideCloseButton);
            }
        }
    }

    updateActiveMemberships() {
        const { onSignIn, formData: { activeMemberships } } = this.props;

        if (isEmpty(activeMemberships)) {
            onSignIn();
        }

        this.setState(formStateHelpers.updateActiveMemberships(activeMemberships));
    }

    updateAvailableCounties() {
        const { formData: { county } } = this.props;
        const receivedCountry = get(this.state, formConstants.country, null);

        this.setState(formStateHelpers.updateAvailableCounties(receivedCountry, county));
    }

    updateAvailableStates() {
        const { formData: { state } } = this.props;
        const receivedCountry = get(this.state, formConstants.country, null);

        this.setState(formStateHelpers.updateAvailableStates(receivedCountry, state));
    }

    handleAccountUpgradeSuccess() {
        const {
            actions,
            formData,
            userAddedToAddressBookSuccessful,
            saveUserToAddressBookErrorMessages
        } = this.props;

        this.setState(formStateHelpers.handleSubmit(false));

        const { currentUser } = hasValue(formData) ? formData : { currentUser: {} };

        if (!userAddedToAddressBookSuccessful && !hasValue(saveUserToAddressBookErrorMessages)) {
            actions.saveUserToAddressBook(formData, currentUser);
            return;
        }

        if (formData.reloadPage) {
            reloadPage();
            return;
        }

        if (formData.oneClubHubData === null || formData.oneClubHubData === undefined || formData.oneClubHubData.IsOneClubHubUpgrade === false) {
            actions.retryPurchase();
        } else {
            redirectTo(formData.oneClubHubData.ReturnUrl);
        }
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { formData } = this.props;
        const { reCaptcha } = this.state;

        if (reCaptcha) {
            formData.reCaptchaToken = reCaptcha;
        }

        this.setState(formStateHelpers.handleSubmit(true));
        this.setState(formStateHelpers.handleFormValidation(formData), this.handleValidationResult);
    }

    handleValidationResult() {
        if (this.state.formHasErrors) {
            const { errors } = this.state;
            formScrollHelpers.scrollToInvalidField(errors, this.formReferences);
            return;
        }

        this.setState(formStateHelpers.updateSavingState(true), this.submitUserDetailsData);
    }

    submitUserDetailsData() {
        const { actions, formData } = this.props;
        const { callBackUrlPut, currentUser } = formData;

        formScrollHelpers.scrollToField(this.formReferences[formConstants.title]);
        actions.upgradeToOneClubAccount(this.state, currentUser, callBackUrlPut);

        GTMUserActions.trackJoinTheOneClubAction();
    }

    displayForm() {
        const {
            onSignIn,
            isUpgradeSuccessful,
            accountUpgradeMessages,
            isPaymentAttemptSuccessful,
            purchaseAttemptMessages,
            formData
        } = this.props;

        if (isEmpty(formData)) {
            return null;
        }
        const messagesToDisplay = _.isEmpty(accountUpgradeMessages) ? purchaseAttemptMessages : accountUpgradeMessages;
        const isOneClub = formData.activeMemberships.includes(MembershipTypes.OneClub);
        const headerTitle = isOneClub ? formMessageConstants.completeToOneClubAccount : formMessageConstants.upgradeToOneClubAccount;

        return (<Fragment>
            <SSOFormHeader
                headerTitle={headerTitle}
                messageOnNewRow={false}></SSOFormHeader>
            <form onSubmit={this.handleSubmit}>
                <FormMessage
                    formRef={this.formMessageRef}
                    isSuccessMessage={isUpgradeSuccessful || isPaymentAttemptSuccessful}
                    messages={messagesToDisplay}></FormMessage>
                {this.displayUpgradeToOneClubAccountForm()}
                <SSOFormFooter
                    onSubmit={this.handleSubmit}
                    linkCallBackUrl={onSignIn}
                    footerButtonText={formMessageConstants.upgradeAccount}
                    footerLinkText={`${formMessageConstants.alreadyHaveAOneClubAccount} ${formMessageConstants.signInHere}`}></SSOFormFooter>
            </form>
        </Fragment>
        );
    }

    displayUpgradeToOneClubAccountForm() {
        const { actions, formData } = this.props;
        const { availableCounties, country, availableStates } = this.state;
        const { county, mobilePhone, state } = formData;
        const copyOfFormData = deepCopyObject(formData);
        const stateFieldDefaultValue = findOptionInSelectField(copyOfFormData[formConstants.state], this.state[formConstants.state], formFieldConstants.selectFieldOptionsCode);

        if (formData.formType === ssoFormTypes.UpgradeToOneClubAccountFromDefault) {
            copyOfFormData[formConstants.country].defaultValue = this.state[formConstants.country];
            copyOfFormData[formConstants.county].defaultValue = this.state[formConstants.county];
            copyOfFormData[formConstants.state].defaultValue = stateFieldDefaultValue;
            copyOfFormData[formConstants.city].defaultValue = this.state[formConstants.city];
            copyOfFormData[formConstants.addressLine1].defaultValue = this.state[formConstants.addressLine1];
            copyOfFormData[formConstants.addressLine2].defaultValue = this.state[formConstants.addressLine2];
            copyOfFormData[formConstants.addressLine3].defaultValue = this.state[formConstants.addressLine3];
            copyOfFormData[formConstants.postcode].defaultValue = this.state[formConstants.postcode];
            copyOfFormData[formConstants.title].defaultValue = this.state[formConstants.title];

            if (this.state[formConstants.mobilePhone]) {
                if (!copyOfFormData[formConstants.mobilePhone].defaultValue) {
                    copyOfFormData[formConstants.mobilePhone].defaultValue = {};
                    copyOfFormData[formConstants.mobilePhone].defaultValue.selectedCountry = this.state[formConstants.mobilePhone].selectedCountry;
                    copyOfFormData[formConstants.mobilePhone].defaultValue.phoneNumber = this.state[formConstants.mobilePhone].phoneNumber;
                }
            }

            if (this.state[formConstants.dateOfBirth] !== undefined && this.state[formConstants.dateOfBirth] instanceof Date && !isNaN(this.state[formConstants.dateOfBirth])) {
                if (!copyOfFormData[formConstants.dateOfBirth].defaultValue) {
                    copyOfFormData[formConstants.dateOfBirth].defaultValue = this.state[formConstants.dateOfBirth];
                }
            }
        }

        return FormBuilder({
            formData: copyOfFormData,
            formReferences: this.formReferences,
            countryData: { selectedCountry: country },
            countyData: { availableCounties, label: county ? county.label : formMessageConstants.emptyString },
            stateData: { availableStates, label: state ? state.label : formMessageConstants.emptyString },
            handleChange: (event) => { this.setState(formStateHelpers.handleFieldChange(event.target)); },
            handleFieldChange: (event) => { this.setState(formStateHelpers.handleFieldChangeWithValidation(event.target)); },
            handleDateChange: (event) => { this.setState(formStateHelpers.handleDateChange(event)); },
            handleMobilePhoneChange: (event) => { this.setState(formStateHelpers.handleMobilePhoneChange(event, mobilePhone.isOptional)); },
            handleCaptchaChange: (token) => { this.setState(formStateHelpers.handleCaptchaChange(token)); },
            handleCountryChange: (event) => {
                this.setState(formStateHelpers.handleCountryChange(event.target, county, state),
                    () => {
                        actions.resetRetrievedUserAddress();
                    });
            },
            handleFieldValidState: (fieldName) => {
                const { errors } = this.state;
                return formFieldDisplayHelpers.handleFieldValidState(fieldName, errors);
            },
        });
    }

    render() {
        const { isSaving } = this.state;
        const { loading, formData, ssoFormType } = this.props;

        const { desktopImageSrc, mobileImageSrc } = formData;

        return (
            <div ref={this.formReference} className={`modal__content form-container form-container__full ${hasValue(desktopImageSrc) ? (ssoFormType === ssoFormTypes.UpgradeToOneClubAccountFromDefault ? 'form-container__wide' : 'form-container__full') : ''}`}>
                <div className={getFormContainerWideLeftClassList(this.props)}>
                    {
                        hasValue(mobileImageSrc) &&
                        <div>
                            <img src={mobileImageSrc} className='form-container__banner--mobile' data-sizes="auto" />
                        </div>
                    }
                    <div className='form-container__form'>
                        {(isSaving || loading) ? <FormSpinner>/</FormSpinner> : null}
                        {this.displayForm()}
                    </div>
                </div>
                {
                    hasValue(desktopImageSrc) && ssoFormType === ssoFormTypes.UpgradeToOneClubAccountFromDefault &&
                    <div className='form-container__wide--right'>
                        <img src={desktopImageSrc} className='form-container__banner--desktop' data-sizes="auto" />
                    </div>
                }
            </div>
        );
    }
}

UpgradeToOneClubAccountForm.propTypes = {
    onSignIn: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
    formData: PropTypes.object
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        isUpgradeSuccessful: state.upgradeAccountForm.isUpgradeSuccessful,
        accountUpgradeMessages: state.upgradeAccountForm.accountUpgradeMessages,
        isPaymentAttemptSuccessful: state.basket.isPaymentAttemptSuccessful,
        purchaseAttemptMessages: state.basket.purchaseAttemptMessages,
        isUserAddressRetrieveSuccessful: state.userAddressSearchData.isUserAddressRetrieveSuccessful,
        retrieveAddressMessages: state.userAddressSearchData.retrieveAddressMessages,
        retrievedUserAddress: state.userAddressSearchData.retrievedUserAddress,
        userAddedToAddressBookSuccessful: state.userAccount.userAddedToAddressBookSuccessful,
        saveUserToAddressBookErrorMessages: state.userAccount.saveUserToAddressBookErrorMessages
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            upgradeToOneClubAccount: bindActionCreators(upgradeAccountActions.upgradeToOneClubAccount, dispatch),
            resetUpgradeAccountFormState: bindActionCreators(upgradeAccountActions.resetUpgradeAccountFormState, dispatch),
            retryPurchase: bindActionCreators(basketActions.retryPurchase, dispatch),
            resetRetrievedUserAddress: bindActionCreators(userAddressActions.resetRetrievedUserAddress, dispatch),
            saveUserToAddressBook: bindActionCreators(userAccountActions.saveUserToAddressBook, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpgradeToOneClubAccountForm);
